import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus, { ElMessage } from 'element-plus'

import SlideVerify from '@/pages/components/slide-verify.vue'
import print from 'vue3-print-nb'
import { Vue2CompatPlugin } from '@/lib/vue2-compat'
import gestureSearch from '@/components/common/gestureSearch/index.js'
// 常量
import { MY_CONSTANTS } from '@/util/constants'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs' // 引入中文语言包
import '@/assets/style/index.css' // 引入elementUI样式
import '@/assets/style/index.scss' // 自定义样式
import 'vue-cropper/dist/index.css'
import 'vxe-table/es/style.css'
import 'animate.css'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@icon-park/vue-next/styles/index.css'; // icon-park图标库
// import '@/assets/style/style.scss?=1.1' //- 大刘定义的公共css样式
// import '@/assets/style/globalCss/index.css' //- elementui定义的公共css样式

import customLoading from '@/components/common/customLoading.vue'
import { setDirectives } from '@/api/directives.js'
import { VueDraggable } from 'vue-draggable-plus'
import directives from './directives';
import { debounce } from 'lodash'
import msgMessage from '@/components/common/popPrompt/index'

import VxeUITable from 'vxe-table'

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16); // 增加 16ms 防抖
    super(callback);
  }
};

const app = createApp(App)
app.config.globalProperties = MY_CONSTANTS

setDirectives(app)

app.use(router)
app.use(store)
app.use(print); //注册
app.use(ElementPlus, {
    locale: zhCn, // 设置语言为中文
})
app.use(Vue2CompatPlugin)

app.use(msgMessage)

app.use(gestureSearch)

// 使用插件安装机制，全局注册所有自定义指令
app.use(directives);

app.use(VxeUITable)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 注册全局组件
app.component('SlideVerify', SlideVerify)
app.component('customLoading', customLoading)

app.component('VueDraggable', VueDraggable )

// 配置 Vue 忽略特定的自定义元素
app.config.compilerOptions.isCustomElement = (tag) => {
  return ['video-rtc', 'video-stream'].includes(tag)
}

// 将 ElMessage 转换为符合你使用习惯的格式
app.config.globalProperties.$message = ElMessage;

app.mount('#app')
